export const ReadableCategories: Record<string, string> = {
	'all': 'sidebar.menu./files/all',
	'purchase-orders': 'sidebar.menu./files/purchase-orders',
	'receipts': 'sidebar.menu./files/receipts',
	'general-documents': 'sidebar.menu./files/general-documents',
	'invoices': 'sidebar.menu./files/invoices',
	'custom': 'sidebar.menu./files/custom',
	'undefined': '-',
};
